module.exports = __webpack_public_path__ + "img/btn-download.17dffaef.png";